module.exports = __webpack_public_path__ + "static/ringcentral-logo-1144af8dfe627f57430807580bfec884.svg";